import { SERVER_URL } from "../../utils/constants";
import HttpRequest from "../../utils/HttpRequest";

export const getAllCategoryService = async (query: string) => {
  return HttpRequest.get(`${SERVER_URL}/product/category${query}`);
};
